<div #default_layout class="default__layout">

  <aside class="default__aside" *ngIf="showAside">
    <div class="button__menu">
      <button mat-button (click)="toggle()">
        <img src="../../../assets/icons/icon-menu.svg">
      </button>
    </div>
    <!-- <mat-card class="aside__card"> -->
    <!-- <div mat-card-avatar>
				<app-avatar name="TEST" class="avatar__aside"></app-avatar>
			</div> -->
    <!-- <div mat-card-avatar class="avatar__account"></div>
		</mat-card> -->
    <!-- <div class="aside__menu" [class.aside__menu__active]="item.active"
			(mouseenter)="selectedItemMenuAside(item, $event)" *ngFor="let item of listMenu">
			<button mat-button class="menu__item" (click)="selectedItemMenuAside(item, $event)"
				[matTooltip]="item.title">
				<img src="../../../assets/icons/{{item.icon}}.svg">
			</button>
		</div> -->
  </aside>

  <mat-sidenav-container class="default__sidenav" [hasBackdrop]="hasBackdrop">
    <mat-sidenav #sidenav [class.sidenav]="showSidenav" [class.sidenav__expansion-panel]="showSidenav" position="start">
      <section [class.hide]="!showSidenav">
        <div class="button__menu">
          <button mat-button (click)="toggle()">
            <img src="../../../assets/icons/icon-menu.svg">
          </button>
        </div>
        <!-- <mat-card class="sidenav__card">
					<mat-card-header> -->
        <!-- <div mat-card-avatar class="card__avatar">
                            <app-avatar name="TESTE" class="avatar__sidenav"></app-avatar>
                        </div> -->
        <!-- <div mat-card-avatar class="avatar__account"></div> -->
        <!-- <mat-card-title class="card__title">
							Bem-vindo <strong>{{name}}!</strong>
						</mat-card-title> -->
        <!-- <mat-card-title class="card__title">
							Bem-vindo
						</mat-card-title>
					</mat-card-header>
				</mat-card> -->
        <!-- <div
					class="sidenav__menu"
					[class.sidenav__menu__active]="item.active"
					(click)="selectedItemMenuSidenav(item)"
					*ngFor="let item of listMenu"
				>
					<button mat-button class="menu__item">
						<div>
							<img src="../../../assets/icons/{{item.icon}}.svg">
							<div>{{item.title}}</div>
							<mat-icon>chevron_right</mat-icon>
						</div>
					</button>
				</div> -->
        <mat-accordion #accordion="matAccordion">
          <mat-expansion-panel class="sidenav__menu" [class.sidenav__menu__active]="item.active"
            *ngFor="let item of listMenu">
            <mat-expansion-panel-header class="expansion__header" (click)="closeSidenavSubmenu()">
              <mat-panel-title>
                <div class="title">{{item.title}}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <button class="menu__item" (click)="selectSubmenuSidenav(submenu)" *ngFor="let submenu of item.submenu">
              <div>
                <img src="../../../assets/icons/{{submenu.icon}}.svg">
                <div>{{submenu.title}}</div>
                <mat-icon *ngIf="menuHasLevels(submenu)">chevron_right</mat-icon>
              </div>
            </button>

          </mat-expansion-panel>
        </mat-accordion>

      </section>
    </mat-sidenav>

    <mat-sidenav #sidenav_submenu class="sidenav__submenu" (mouseleave)="submenuMouseLeave()"
      [class.hide]="!showSidenavSubMenu || !showSidenav" [class.sidenav__expansion-panel]="showSidenavSubMenu"
      position="end" [@.disabled]="true">
      <section>
        <div>
          <div class="header__panel">
            <img src="../../../assets/icons/icon-feather-arrow-left-circle.svg" (click)="closeSidenavSubmenu()" />
            <span class="panel__title">{{menu?.title.toUpperCase()}}</span>
          </div>
        </div>
        <div *ngFor="let item of menu?.submenu">
          <div class="submenu" (click)="navigatePage(item.page)">
            <img src="../../../assets/icons/{{item.icon}}.svg" />
            <span class="item__name">{{item.title}}</span>
          </div>
        </div>
        <!-- <mat-accordion  multi>
							<mat-expansion-panel
									class="expansion__panel"
									[class.expansion__panel__black]="panel.isExpanded"
									[disabled]="panel.isDisabled"
									[expanded]="panel.isExpanded"
									(opened)="beforePanelOpened(panel)"
									(closed)="beforePanelClosed(panel)"
									*ngFor="let panel of accordionList"
							>
								<mat-expansion-panel-header>
									<mat-panel-title class="title">
											<img src="../../../assets/icons/icon-file-1.svg"/>
											<span>Tabela Recursal Tomador</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-panel-description>
									<p>
											Consultar tomador
											Cadastrar novo tomador
									</p>
								</mat-panel-description>
							</mat-expansion-panel>
					</mat-accordion> -->
      </section>
    </mat-sidenav>
    <mat-sidenav-content>
      <app-header (buttonToggle)="toggleResponsive()"></app-header>
      <router-outlet></router-outlet>
      <footer>
        <div class="row row-footer">
          <div class="footer-content">
            Daycoval Seguros. Todos os direitos reservados. Versão {{version}}
          </div>
        </div>
      </footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
